// extracted by mini-css-extract-plugin
export var center = "_1n-2";
export var clickableRow = "_1n-5";
export var expandedRow = "_1n-7";
export var hoverable = "_1n-4";
export var left = "_1n-1";
export var right = "_1n-3";
export var row = "_1n-0";
export var selectedRow = "_1n-6";
export var summaryRow = "_1n-8";